import script from "./ListingDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./ListingDetails.vue?vue&type=script&setup=true&lang=js"

import "./ListingDetails.vue?vue&type=style&index=0&id=a24512f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a24512f0"]])

export default __exports__